import { Button } from "../../../../components/Button/Button.tsx";
import { useCreateModel } from "../../../Home/HomeIndex/hooks/useCreateModel.ts";
import type { ModelType } from "../../../types.ts";

export const ModelCreationButton = ({
  modelType,
}: {
  modelType: ModelType;
}) => {
  const { createModel, isCreateModelLoading } = useCreateModel();
  return (
    <Button
      variant="secondary"
      size="md"
      loading={isCreateModelLoading}
      onClick={() => {
        createModel({ type: modelType });
      }}
      iconName="Plus"
      iconPosition="left"
    >
      <div className="flex-row-center gap-100">
        <div className="label-md-default">
          Create {modelType.toLocaleLowerCase()}
        </div>
      </div>
    </Button>
  );
};
